var map = {
	"./config": [
		5220
	],
	"./config.js": [
		5220
	],
	"./de": [
		26007
	],
	"./de.js": [
		26007
	],
	"./en": [
		8306,
		306
	],
	"./en.js": [
		8306,
		306
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 84051;
module.exports = webpackAsyncContext;